var GoogleLogin = (function () {
    try {
        if (!window.googleApiAvailable) return;

        var googleSignIn = null;
        var isElectron;
        return {
            clickGoogleLoginButton: clickGoogleLoginButton,
            googleMiniLoginCallback: googleMiniLoginCallback,
            loadOneTab : loadOneTab,
        }
        function loadOneTab() {
            googleSignIn = new GoogleSignInApi(googleLoginCallback);
            if (isElectron && ElectronApi.Comm.getVersion() < "1_0_6") {
                return;
            }

            // 원탭은 현재 글로벌만 처리
            if( Often.isMobile() || Often.isTablet()) {
                return;
            }

            googleSignIn.loadInAuth2Client(true);
            return;
        }

        function clickGoogleLoginButton(e) {
            isElectron = ElectronApi.Comm.isElectron();
            googleSignIn = new GoogleSignInApi(googleLoginCallback);

            if (isElectron && ElectronApi.Comm.getVersion() < "1_0_6") {
                alert(c18n('DL163', "구글 정책 변경으로 인하여 구글 로그인은 브라우저를 통해서만 이용할 수 있습니다."));
                return;
            }

            const isRenewalSignUp = !!window?.isRenewalSignUp;
            if (!isRenewalSignUp && Often.isMobile()) {
                MobileApp.goMarketOrApp({USER_ID: _USER_ID});
                return;
            }

            if(GoogleOAuth.isUsable()) {
                googleSignIn.loadInAuth2Client(false);
                return;
            }

            if (isElectron) {
                googleSignIn.loadOnDesktopApp();
                return;
            }
            GoogleOAuth.isUsable() && googleSignIn.loadOnWebBrowser();
        }

        async function googleLoginCallback(googleBasicProfile) {
            if(!Often.isGlobal()) {
                GoogleTagManager.collect({
                    event: "guest",
                    userId: googleBasicProfile.getEmail(),
                    guestDate: Time.currentTime()
                });
            }

            const isFuncOfRenewalSignUp = !!window?.isRenewalSignUp;
            const basicProfile = getGoogleBasicProfileJson(googleBasicProfile);
            if(!isFuncOfRenewalSignUp) {
                CommonLogin.goLogin(basicProfile);
                return;
            }


            if(Often.isGlobal() || Mutil.isAct("newSignup.act")) {
                const SignUpViewChanger = requireModule('SignUpViewChanger', {on: ['signup', 'index', 'newSignup']})();
                SignUpViewChanger.loadSocialLoginSuccess(basicProfile);  // ID가 플로우 유저가 아니면  회원가입 페이지로 이동.
                return;
            }

            //ID가 플로우 유저가 아니면  INPUT에 오류 표시..
            CommonLogin.goLogin(basicProfile);
        }
        function getGoogleBasicProfileJson(googleBasicProfile) {
            return {
                "USER_ID": googleBasicProfile.getEmail(),
                "ID_GB": SignCode.TYPE.GOOGLE,
                "OBJ_CNTS_NM": (isElectron ? "desktop" : ""),
                "EMAIL": googleBasicProfile.getEmail(),
                "USER_NM": googleBasicProfile.getName(),
                "PRFL_PHTG": Often.null2Void(googleBasicProfile.getImageUrl()),
            };
        }

        function googleMiniLoginCallback(token) {
            gapi.client.setToken(token);
            gapi.client.init({
                clientId: GoogleOAuth.getKey(ServerChecker.isReal).clientId,
                scope: 'profile'
            }).then(function () {
                var profile = gapi.auth2.getAuthInstance().currentUser.get().getBasicProfile();
                if (profile) {
                    googleLoginCallback(profile);
                } else {

                }
            });
        }
    } catch (e) {
        console.error(e);
    }
})();

var GoogleSignInDriveApi = function (loadCallback) {

    var googleUser;
    var reloadTimer;
    var auth2;
    var tokenClient;

    this.load = function () {
        if(Often.isGlobal()) {
            gapi.load('client:auth2', onAuthApiLoad_Global);
        } else {
            gapi.load('auth2', onAuthApiLoad);
        }
    }

    /**
     * 2023.03.31 라이브러리 지원 종료에 따른 신규 API 이용
     * @Docs https://developers.google.com/identity/oauth2/web/guides/use-token-model?hl=ko
     * Callback after Google Identity Services are loaded.
     * */
    function onAuthApiLoad_Global() {
        const config = getGoogleAuthConfig();
        //보안 문제로 인해 팝업 UX만 지원됩니다.
        tokenClient = google.accounts.oauth2.initTokenClient({
            client_id: GoogleOAuth.getKey(ServerChecker.isReal).clientId,
            scope: 'https://www.googleapis.com/auth/drive.file',
            callback : (response) => { handleCredentialResponse(response); },
            immediate: true,
            cookie_policy: 'none'
        });
        tokenClient.requestAccessToken({prompt: ''});
    }

    function handleCredentialResponse(response){
        const accessToken = response.access_token;
        (typeof loadCallback === "function") && loadCallback(accessToken)
    }


    /**
     * 이전버전 API 이용
     * @Docs https://developers.google.com/identity/sign-in/web/listeners?hl=ko
     * */
    function onAuthApiLoad() {

        try {
            auth2 = gapi.auth2.init(getGoogleAuthConfig());
        } catch (e) {
            if (e.error === 'Cookies are not enabled in current environment.') {
                Often.toast("error", "This is a limited feature in Incognito Browser (Secret Browser).");
            } else {
                Often.toast("error", e.error);
            }
        }

        auth2.isSignedIn.listen(signInChanged);
        auth2.currentUser.listen(userChanged);
        if (auth2.isSignedIn.get()) {
            auth2.signIn();
        } else {
            reloadTimer = setTimeout(function () {
                gapi.auth2.getAuthInstance().signIn();
            }, 1000);
        }
        refreshValues();
    }

    function refreshValues() {
        auth2 && userChanged(auth2.currentUser.get());
    }

    function userChanged(user) {
        googleUser = user;
        user && auth2.isSignedIn.get() && clearTimeout(reloadTimer);
    }

    function signInChanged(val) {
        if (!val) return;
        var isElectron = ElectronApi.Comm.isElectron();
        var accessToken = googleUser.getAuthResponse().access_token;
        if (isElectron) {
            ElectronApi.Thirdparty.google.driveInPost({ token: accessToken });
            // Electron.openGoogleDrivePost(accessToken);
            return;
        }
        (typeof loadCallback === "function") && loadCallback(accessToken)
    }

    function getGoogleAuthConfig() {
        var googleAuthConfig = {
            client_id: GoogleOAuth.getKey(ServerChecker.isReal).clientId,
            scope: GoogleOAuth.getScope("Drive"),
        }
        if (Often.isMessenger()) {
            googleAuthConfig["ux_mode"] = "redirect"
            googleAuthConfig["redirect_uri"] = Often.getLocOrigin() + "/flow-renewal/view/subscreen_view.jsp?GB=GOOGLE_DRIVE"
        }
        return googleAuthConfig;
    }
}

var GoogleSignInApi = function (loginCallback) {

    var auth2;

    this.loadOnWebBrowser = function () {
        gapi.load('auth2', function () {
            auth2 = gapi.auth2.init({
                client_id: GoogleOAuth.getKey(ServerChecker.isReal).clientId,
                scope: 'profile'
            });

            auth2.signIn().then(function () {
                successSignIn(loginCallback);
                Often.setCookie("ONLY_CHATBOT_ID_LIST", "Y");
            });
        });
    }
    this.loadInAuth2Client =  (isOneTab = false) => {
        gapi.load('client:auth2', () => {
            if(isOneTab) {
                loadOneTab();
                return;
            }

            openSignInPopup();

            function openSignInPopup() {
                google.accounts.id.cancel();
                const googleInitialJson = makeGoogleInitialJson();
                google.accounts.id.initialize(googleInitialJson);
                const $fakeButtonLayer = createFakeButtonLayer();
                window.google.accounts.id.renderButton($fakeButtonLayer[0], {
                    type: "icon",
                });
                const fakeButton = $fakeButtonLayer.find("div[role=button]");
                fakeButton.click();
            }

            function loadOneTab() {
                google.accounts.id.cancel();
                const googleInitialJson = makeGoogleInitialJson();
                const oneTabLayer = createOneTabLayer();
                googleInitialJson.prompt_parent_id = oneTabLayer.prop("id")
                google.accounts.id.initialize(googleInitialJson);
                // 원탭 로그인
                google.accounts.id.prompt((notification) => {
                    if (notification.isNotDisplayed() || notification.isSkippedMoment()) {
                        Mutil.mlog("This browser does not use the Google One-tap ");
                    }
                })
            }

            function createFakeButtonLayer() {
                if($("#fakeGoogleLoginLayer").length > 0) {
                    return $("#fakeGoogleLoginLayer");
                }

                const googleLoginWrapper = document.createElement("div");
                // Or you can simple hide it in CSS rule for custom-google-button
                googleLoginWrapper.style.display = "none";
                googleLoginWrapper.id="fakeGoogleLoginLayer";
                document.body.appendChild(googleLoginWrapper);
                return $(googleLoginWrapper);
            }

            function createOneTabLayer() {
                if($("#g_id_onload").length > 0) {
                    return $("#g_id_onload");
                }
                const oneTabLayer = $(`<div id="g_id_onload"
                                            data-prompt_parent_id="g_id_onload" 
                                            style="position: fixed; top: 129px; right: 389px; width: 0; height: 0; z-index: 1001;"></div>`)
                $("body").append(oneTabLayer);
                return oneTabLayer;
            }

            function makeGoogleInitialJson() {
                return {
                    client_id: GoogleOAuth.getKey(ServerChecker.isReal).clientId,
                    callback: (response) => {
                        const makeProfile = (jwt) => {
                            const payloads = Often.parseJwt(jwt);
                            return {
                                getEmail: () => payloads?.email,
                                getName: () => payloads?.name,
                                getImageUrl: () => payloads?.picture,
                            }
                        }


                        if (typeof loginCallback === "function") {
                            loginCallback(makeProfile(response.credential));
                        }
                    },

                    auto_select :  Mutil.isAct("newSignup.act"),
                    cancel_on_tap_outside : true,
                    ux_mode: "popup"
                };
            }
        });


    }



    this.loadOnDesktopApp = function () {
        gapi.load("auth", {
            callback: onAuthApiLoad
        });
    };

    var onAuthApiLoad = function () {
        try {
            gapi.auth.authorize({
                'client_id': GoogleOAuth.getKey(ServerChecker.isReal).clientId,
                'scope': GoogleOAuth.getScope("SignIn"),
                'immediate': true
            }, handleAuthResult)
        } catch (e) {

        }
    };

    var handleAuthResult = function () {
        Often.setCookie("googleLoginYn", "Y");
        const url = GoogleOAuth.getRedirectUri("SignIn");
        const title =  "Google";
        ElectronApi.Thirdparty.google.openSignin(url, title);
    };

    function successSignIn(loginCallback) {

        var isEnterLogin = $("#enterpriseLoginDiv").is(":visible");
        var isBusinessLogin = $("#businessLoginDiv").is(":visible");

        if (isBusinessLogin) return;

        var GoogleUser = auth2.currentUser.get();
        var profile = GoogleUser.getBasicProfile();
        GoogleUser.disconnect();
        signOut();
        if (isEnterLogin) {
            //entLogin.fn_goLogin("3");
        } else {
            if (typeof loginCallback === "function") {
                loginCallback(profile);
            }
        }

        function signOut() {
            var auth2 = gapi.auth2.getAuthInstance();
            auth2.signOut().then();
            auth2.disconnect();
        }

    }
};
